"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const styles_1 = require("@material-ui/core/styles");
const Close_1 = require("@material-ui/icons/Close");
const FilterUtils = require("@pbl/pbl-react-core/lib/models/filters/filsters-utils");
const classnames_1 = require("classnames");
const _ = require("lodash");
const react_i18next_1 = require("react-i18next");
const FilterSectionStyle_1 = require("./jss/FilterSectionStyle");
const SelectedFiltersSection = ({ filters, classes, entityName, darkMode, onRemoveSelected, t }) => {
    const hasSelected = FilterUtils.hasSelected(filters);
    if (!hasSelected)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.filterSelectedSection }, { children: Object.keys(filters).map(key => {
            const section = filters[key] || {};
            return _.filter(section.filters, filter => filter.isSelected).map(filter => {
                const onClick = () => {
                    onRemoveSelected(entityName, section.key, filter.name);
                };
                const displayName = filter.customDateFilterType === 'custom' &&
                    filter.customDateRangeStart &&
                    filter.customDateRangeEnd
                    ? filter.customDateRangeStart.format('MMM Do, YYYY') +
                        ' to ' +
                        filter.customDateRangeEnd.format('MMM Do, YYYY')
                    : t(filter.name);
                return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: "contained", className: (0, classnames_1.default)({
                        [classes.filterItemSelectedDark]: darkMode,
                        [classes.filtersItemSelected]: !darkMode
                    }, classes.filterItem), size: "small", onClick: onClick, "aria-label": filter.name }, { children: [displayName, (0, jsx_runtime_1.jsx)(Close_1.default, { style: { marginLeft: 4 }, fontSize: "small" })] }), `selected_${filter.name}`));
            });
        }) })));
};
exports.default = (0, styles_1.withStyles)(FilterSectionStyle_1.default)((0, react_i18next_1.withTranslation)()(SelectedFiltersSection));
//# sourceMappingURL=SelectedFiltersSection.js.map